const GET_USERS_BY_SEARCH_TEXT = 'GET_USERS_BY_SEARCH_TEXT'
const SET_USERS_BY_SEARCH_TEXT = 'SET_USERS_BY_SEARCH_TEXT'

const ADD_EMPLOYEE_TO_COST_CENTER = 'ADD_EMPLOYEE_TO_COST_CENTER'
const SET_IS_EMPLOYEE_ADDED_TO_COST_CENTER = 'SET_IS_EMPLOYEE_ADDED_TO_COST_CENTER'

const GET_EMPLOYEES_WITH_HOME_COST_CENTER_LIST = 'GET_EMPLOYEES_WITH_HOME_COST_CENTER_LIST'
const SET_EMPLOYEES_WITH_HOME_COST_CENTER_LIST = 'SET_EMPLOYEES_WITH_HOME_COST_CENTER_LIST'

export {
    GET_USERS_BY_SEARCH_TEXT,
    SET_USERS_BY_SEARCH_TEXT,
    ADD_EMPLOYEE_TO_COST_CENTER,
    SET_IS_EMPLOYEE_ADDED_TO_COST_CENTER,
    GET_EMPLOYEES_WITH_HOME_COST_CENTER_LIST,
    SET_EMPLOYEES_WITH_HOME_COST_CENTER_LIST
}